module.exports = __webpack_public_path__ + "54cf98f5/img/menu-icon.5f8facae.svg";